import { useContext ,useEffect} from 'react';
import LanguageContext from '../context/language-context';
import languages from '../../translations/languages';


const TranslationButton = (props) => {


    const languageCtx = useContext(LanguageContext);

    useEffect(() => {
        let tmpLng =  languages.includes(languageCtx.language) ? languageCtx.language : languages[0]
        languageCtx.setLanguage(tmpLng);
    },[]);

    function clickButton(e) {
        e.preventDefault();
        let x = languageCtx.language;
        let currentIndex = languages.indexOf(x);
        x = languages[(currentIndex + 1) % languages.length];
        languageCtx.setLanguage(x);
    }

    return (
        <>
            <button  onClick={(e) => clickButton(e)}  className='button-standard'> {languageCtx.language} </button>
        </>
    )
}

export default TranslationButton 